<template>

    <span>
        <svg width="18px" height="18px">
            <g>
                <circle cx="9" cy="9" r="9" stroke="black" stroke-width="0" :fill="colorFill" />
            </g>
        </svg>
    </span>

</template>

<script>

export default {
    name: 'spot',

    props: {
        color: String,
    },

    computed: {
        colorFill()
        {
            switch (this.color)
            {
                case 'vert':
                    return '#70d2ab'; // 'hsl(156, 52%, 63%)';
                case 'jaune':
                    return '#f5df65'; // 'hsl(47, 70%, 73%)';
                case 'orange':
                    return '#f4a34d'; // 'hsl(28, 73%, 67%)';
                case 'rouge':
                    return '#ff6362'; // 'hsl(358, 68%, 70%)';

                case 'perfect':
                    return '#8cc63f';
                case 'cinq':
                    return '#5bb991';
                case 'quinze':
                    return '#29abe2';
                case 'vingtcinq':
                    return '#486cba';
                case 'trentecinq':
                    return '#662d91';
                case 'more':
                    return '#bc2050';

            }
            return 'gray';
        },
    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/spot.vue